import get from 'lodash-es/get';

import {
  getTravelCheckoutFormValues,
  getTravelCheckoutInsurantData,
  setSectionMessageVisibility,
  setSectionVisibilityHelper,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  MessagesEnum,
  SectionsEnum,
  TravelInsurantSelectionEnum,
} from 'app/shared/enums';
import { checkIsDataObfuscated } from '../helpers/checkIsDataObfuscated';
import { revalidatePeselsUniqueness } from 'app/services/pesel.service/revalidatePeselsUniqueness';

const formName = FormsEnum.TravelCheckoutForm;

export const setupTravelInsurant = {
  setupTravelInsurant() {
    const signer = get(
      getTravelCheckoutFormValues(),
      FieldsEnum.TravelCheckoutContractSigner
    );

    const isNotATraveler =
      !signer || signer === TravelInsurantSelectionEnum.Different;

    if (isNotATraveler) {
      const { name, lastName, peselNumber } = getTravelCheckoutInsurantData();

      const showObfuscatedMessage = [name, lastName, peselNumber].some((item) =>
        checkIsDataObfuscated(item, true)
      );

      setSectionMessageVisibility({
        key: MessagesEnum.TravelInsurantDataObfuscated,
        visible: showObfuscatedMessage,
        formName,
      });
    }

    setSectionVisibilityHelper({
      key: SectionsEnum.TravelCheckoutSectionInsurant,
      formName,
      visible: isNotATraveler,
    });

    revalidatePeselsUniqueness(FormsEnum.TravelCheckoutForm);
  },
};
